<template>
  <header class="main-header flex-main-container">
    <!-- Header Banner Content  -->
    <div class="main-header__banner content-wrapper">
      <!-- Header App logo  -->
      <div class="app-logo">
        <img src="./assets/logo.png" alt="Pocket cloud">
      </div>
      <p class="main-header__banner-description --text-is-gray">
        Manage, watch and scale your Scalingo applications from your mobile<br>
        Monitor your logs and events from your pocket<br>
        Rule the cloud from anywhere
      </p>
      <!-- Get it Buttons  -->
      <div class="main-header__banner-buttons-container">
        <!-- Google button -->
        <a :href="googlePlayUrl"
           class="buttons-container__get-it-button play-store" :class="{'disabled': googlePlayUrl === null}">
          <img
            class="get-it__icon"
            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
            alt='get it on google button'
          />
        </a>
        <!-- Apple button  -->
        <a :href="appStoreUrl" class="buttons-container__get-it-button app-store disabled"
           :class="{'disabled': appStoreUrl === null}">
          <img
            class="get-it__icon"
            src="https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2020-05-12&kind=iossoftware&bubble=ios_apps"
            alt="download on app store button"
          />
        </a>
      </div>

    </div>
    <!-- App Banner image  -->
    <picture>
      <source srcset="./assets/banner-bg-small.webp" type="image/webp">
      <source srcset="./assets/banner-bg.png" type="image/png">
      <img src="./assets/banner-bg.png" alt="Pocket cloud banner" class="main-header__banner-image">
    </picture>
  </header>
  <!-- Main content  -->
  <main class="main-content flex-main-container">
    <!-- About The App  -->
    <section class="main-content__about section content-wrapper">
      <h1 class="about-section__title">
        <span class="has-circle --text-is-white">Ab</span>out The App
      </h1>
      <p class="about-section__description --text-is-gray">
        Pocket Cloud is an unofficial client for
        <scalingo-link></scalingo-link>
        : the
        best french cloud provider.<br>
        Watch your application logs and everything that occurred on the cloud ! <br>
        Available on Android and iOS (Soon !), you can use all the
        <scalingo-link></scalingo-link>
        features on the go<br>
      </p>
    </section>
    <!-- Features Cards Section  -->
    <section class="main-content__feature-cards section content-wrapper">
      <!-- Card 1  -->
      <feature-card v-for="feature in features" :text="feature.text" :title="feature.title"
                    :icon="feature.icon" :key="feature.icon">
      </feature-card>
    </section>
    <!-- Follow Us Section  -->
    <section class="main-content__follow-us section content-wrapper">
      <div class="follow-us-section__data content-wrapper">
        <!-- Ttitle  -->
        <h1 class="follow-us-section__title">
          <span class="has-circle --text-is-white">Fo</span>llow Us On Social Media
        </h1>
        <!-- Description  -->
        <p class="follow-us-section__description --text-is-gray">
          Want to know what's happening, WHEN it's happening ?<br>
          Here it is 👇
        </p>
        <!-- Social Buttons container  -->
        <div class="follow-us-buttons-container content-wrapper">
          <!-- Facebook  -->
          <a v-if="facebookUrl" :href="facebookUrl" target="_blank" class="--normal-size button --facebook-color">
            <svg width="15" height="28" viewBox="0 0 15 28"
                 fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.9084 15.7163L14.6733 10.7322H9.89092V7.4979C9.89092 6.13435 10.559 4.80523 12.7009 4.80523H14.875V0.561816C14.875 0.561816 12.902 0.225098 11.0156 0.225098C7.07722 0.225098 4.50288 2.61225 4.50288 6.93365V10.7322H0.125V15.7163H4.50288V27.765H9.89092V15.7163H13.9084Z"
                fill="white"/>
            </svg>
          </a>
          <!-- Pinterest  -->
          <a v-if="pinterestUrl" :href="pinterestUrl" target="_blank" class="--normal-size button --pinterest-color">
            <svg width="22" height="28" viewBox="0 0 22 28"
                 fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.6954 0.225098C6.17799 0.225098 0.725098 3.90338 0.725098 9.85639C0.725098 13.6422 2.85463 15.7933 4.14525 15.7933C4.67764 15.7933 4.98416 14.309 4.98416 13.8896C4.98416 13.3895 3.70967 12.3247 3.70967 10.2436C3.70967 5.91998 7.00076 2.85475 11.2598 2.85475C14.922 2.85475 17.6323 4.93588 17.6323 8.75936C17.6323 11.6149 16.4869 16.971 12.7763 16.971C11.4373 16.971 10.2919 16.003 10.2919 14.6156C10.2919 12.5828 11.7115 10.6146 11.7115 8.51736C11.7115 4.95739 6.66197 5.6027 6.66197 9.90479C6.66197 10.8082 6.7749 11.8085 7.17822 12.6312C6.43611 15.8255 4.91963 20.5847 4.91963 23.8758C4.91963 24.8922 5.06482 25.8924 5.16162 26.9088C5.34446 27.1131 5.25304 27.0916 5.53268 26.9894C8.24299 23.2789 8.14619 22.5529 9.37228 17.6969C10.0337 18.9553 11.7438 19.6329 13.099 19.6329C18.81 19.6329 21.3751 14.0671 21.3751 9.04975C21.3751 3.70979 16.7611 0.225098 11.6954 0.225098Z"
                fill="white"/>
            </svg>
          </a>
          <!-- Instaram  -->
          <a v-if="instagramUrl" :href="instagramUrl" target="_blank" class="--normal-size button --instagram-color">
            <svg width="25" height="25" viewBox="0 0 25 25"
                 fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.6051 6.65279C9.25474 6.65279 6.55234 9.35521 6.55234 12.7056C6.55234 16.0559 9.25474 18.7583 12.6051 18.7583C15.9554 18.7583 18.6579 16.0559 18.6579 12.7056C18.6579 9.35521 15.9554 6.65279 12.6051 6.65279ZM12.6051 16.6407C10.44 16.6407 8.67001 14.8759 8.67001 12.7056C8.67001 10.5352 10.4347 8.77047 12.6051 8.77047C14.7754 8.77047 16.5402 10.5352 16.5402 12.7056C16.5402 14.8759 14.7702 16.6407 12.6051 16.6407ZM20.3172 6.40521C20.3172 7.19012 19.6851 7.81699 18.9054 7.81699C18.1205 7.81699 17.4937 7.18485 17.4937 6.40521C17.4937 5.62556 18.1258 4.99342 18.9054 4.99342C19.6851 4.99342 20.3172 5.62556 20.3172 6.40521ZM24.3261 7.83806C24.2365 5.9469 23.8045 4.27172 22.4191 2.89154C21.0389 1.51137 19.3637 1.0794 17.4726 0.98458C15.5235 0.873955 9.68144 0.873955 7.73234 0.98458C5.84645 1.07413 4.17127 1.5061 2.78583 2.88628C1.40038 4.26646 0.973688 5.94163 0.878867 7.8328C0.768242 9.7819 0.768242 15.624 0.878867 17.5731C0.96842 19.4642 1.40038 21.1394 2.78583 22.5196C4.17127 23.8998 5.84118 24.3317 7.73234 24.4265C9.68144 24.5372 15.5235 24.5372 17.4726 24.4265C19.3637 24.337 21.0389 23.905 22.4191 22.5196C23.7993 21.1394 24.2312 19.4642 24.3261 17.5731C24.4367 15.624 24.4367 9.78717 24.3261 7.83806ZM21.808 19.6644C21.3971 20.6969 20.6017 21.4923 19.5639 21.9085C18.0099 22.5249 14.3224 22.3826 12.6051 22.3826C10.8878 22.3826 7.19501 22.5196 5.64627 21.9085C4.61377 21.4976 3.81833 20.7022 3.40217 19.6644C2.78583 18.1104 2.92806 14.4229 2.92806 12.7056C2.92806 10.9882 2.7911 7.29547 3.40217 5.74672C3.81306 4.71422 4.6085 3.91878 5.64627 3.50262C7.20028 2.88628 10.8878 3.02851 12.6051 3.02851C14.3224 3.02851 18.0152 2.89154 19.5639 3.50262C20.5964 3.91351 21.3919 4.70896 21.808 5.74672C22.4244 7.30074 22.2821 10.9882 22.2821 12.7056C22.2821 14.4229 22.4244 18.1157 21.808 19.6644Z"
                fill="white"/>
            </svg>
          </a>
          <!-- Twitter  -->
          <a v-if="twitterUrl" :href="twitterUrl" target="_blank" class="--normal-size button --twitter-color">
            <svg width="24" height="21" viewBox="0 0 24 21"
                 fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.5242 5.69314C21.5392 5.90277 21.5392 6.11245 21.5392 6.32209C21.5392 12.7162 16.6724 20.0837 7.7775 20.0837C5.03714 20.0837 2.49147 19.2901 0.350098 17.9125C0.739451 17.9573 1.11378 17.9723 1.51811 17.9723C3.77924 17.9723 5.86074 17.2086 7.52293 15.9059C5.39653 15.8609 3.61455 14.4683 3.00058 12.5515C3.3001 12.5964 3.59957 12.6264 3.91407 12.6264C4.34832 12.6264 4.78261 12.5665 5.1869 12.4617C2.97067 12.0124 1.30843 10.0657 1.30843 7.71472V7.65484C1.95232 8.01424 2.70111 8.23885 3.4947 8.26876C2.19191 7.40022 1.33839 5.91775 1.33839 4.24059C1.33839 3.34213 1.57794 2.51852 1.99726 1.79974C4.37823 4.73476 7.95718 6.65147 11.9703 6.86115C11.8955 6.50176 11.8505 6.12743 11.8505 5.75306C11.8505 3.08755 14.0069 0.91626 16.6873 0.91626C18.08 0.91626 19.3378 1.50027 20.2213 2.44367C21.3145 2.23403 22.3627 1.8297 23.2911 1.27565C22.9317 2.39877 22.168 3.34217 21.1647 3.94112C22.1381 3.83634 23.0815 3.56674 23.95 3.19241C23.2912 4.15075 22.4676 5.00427 21.5242 5.69314Z"
                fill="white"/>
            </svg>
          </a>
        </div>
      </div>
      <!-- Phones image  -->
      <picture>
        <source srcset="./assets/social-media-bg-small.webp" type="image/webp">
        <source srcset="./assets/social-media-bg.png" type="image/png">
        <img class="follow-us-section__image" src="./assets/social-media-bg.png" alt="Social media">
      </picture>
    </section>
    <!-- Suscribe To our Newsletter Form Section -->
    <section class="main-content__suscribe content-wrapper">
      <!-- Arrow vector  -->
      <div class="suscribe-section__arrow-vector">
        <img src="./assets/blue-arrow.png" alt="Subscribe to our newsletter">
      </div>
      <!-- Title  -->
      <h2 class="suscribe-section__title">
        Subscribe To our Newsletter
      </h2>
      <!-- Description  -->
      <p class="suscribe-section__description --text-is-gray">
        Stay in touch with the updates and evolution of the app.
        No Spam or phishing, never !
      </p>
      <!-- Form  -->
      <transition enter-active-class="animate__animated animate__fadeIn animate__fast"
                  leave-active-class="animate__animated animate__fadeOut animate__fast" mode="out-in">
        <p v-if="newsletterSuccess" class="suscribe-section__form successMessage --text-is-gray" key="success">
          See you soon 👌
        </p>
        <form v-else class="suscribe-section__form" @submit.prevent="onSubmit" key="form">
          <label for="email" class="form-content">
            <input required class="suscribe-section__input" placeholder="Here your email" type="email" name="email"
                   id="email" v-model="email" autocomplete="email">
            <button type="submit" class="button suscribe-section__button">Suscribe</button>
          </label>
        </form>
      </transition>
    </section>
  </main>
  <!-- Footer  -->
  <footer class="main-footer flex-main-container">
    <!-- Footer App logo  -->
    <div class="app-logo">
      <img src="./assets/logo.png" alt="Pocket clould">
    </div>
    <!-- Social Buttons container  -->
    <div class="footer__buttons-container content-wrapper">
      <h1 class="footer-follow-us">Follow Us</h1>
      <!-- Facebook  -->
      <a v-if="facebookUrl"
         :href="facebookUrl"
         target="_blank"
         class="--small-size button --button-is-blue"
         aria-label="Facebook"
      >
        <svg width="10" height="20" viewBox="0 0 15 28"
             fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.9084 15.7163L14.6733 10.7322H9.89092V7.4979C9.89092 6.13435 10.559 4.80523 12.7009 4.80523H14.875V0.561816C14.875 0.561816 12.902 0.225098 11.0156 0.225098C7.07722 0.225098 4.50288 2.61225 4.50288 6.93365V10.7322H0.125V15.7163H4.50288V27.765H9.89092V15.7163H13.9084Z"
            fill="white"/>
        </svg>
      </a>
      <!-- Pinterest  -->
      <a v-if="pinterestUrl"
         :href="pinterestUrl"
         target="_blank"
         class="--small-size button --button-is-blue"
         aria-label="Pinterest"
      >
        <svg width="15" height="20" viewBox="0 0 22 28"
             fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.6954 0.225098C6.17799 0.225098 0.725098 3.90338 0.725098 9.85639C0.725098 13.6422 2.85463 15.7933 4.14525 15.7933C4.67764 15.7933 4.98416 14.309 4.98416 13.8896C4.98416 13.3895 3.70967 12.3247 3.70967 10.2436C3.70967 5.91998 7.00076 2.85475 11.2598 2.85475C14.922 2.85475 17.6323 4.93588 17.6323 8.75936C17.6323 11.6149 16.4869 16.971 12.7763 16.971C11.4373 16.971 10.2919 16.003 10.2919 14.6156C10.2919 12.5828 11.7115 10.6146 11.7115 8.51736C11.7115 4.95739 6.66197 5.6027 6.66197 9.90479C6.66197 10.8082 6.7749 11.8085 7.17822 12.6312C6.43611 15.8255 4.91963 20.5847 4.91963 23.8758C4.91963 24.8922 5.06482 25.8924 5.16162 26.9088C5.34446 27.1131 5.25304 27.0916 5.53268 26.9894C8.24299 23.2789 8.14619 22.5529 9.37228 17.6969C10.0337 18.9553 11.7438 19.6329 13.099 19.6329C18.81 19.6329 21.3751 14.0671 21.3751 9.04975C21.3751 3.70979 16.7611 0.225098 11.6954 0.225098Z"
            fill="white"/>
        </svg>
      </a>
      <!-- Instaram  -->
      <a v-if="instagramUrl"
         :href="instagramUrl"
         target="_blank"
         class="--small-size button --button-is-blue"
         aria-label="Instagram"
      >
        <svg width="15" height="15" viewBox="0 0 25 25"
             fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.6051 6.65279C9.25474 6.65279 6.55234 9.35521 6.55234 12.7056C6.55234 16.0559 9.25474 18.7583 12.6051 18.7583C15.9554 18.7583 18.6579 16.0559 18.6579 12.7056C18.6579 9.35521 15.9554 6.65279 12.6051 6.65279ZM12.6051 16.6407C10.44 16.6407 8.67001 14.8759 8.67001 12.7056C8.67001 10.5352 10.4347 8.77047 12.6051 8.77047C14.7754 8.77047 16.5402 10.5352 16.5402 12.7056C16.5402 14.8759 14.7702 16.6407 12.6051 16.6407ZM20.3172 6.40521C20.3172 7.19012 19.6851 7.81699 18.9054 7.81699C18.1205 7.81699 17.4937 7.18485 17.4937 6.40521C17.4937 5.62556 18.1258 4.99342 18.9054 4.99342C19.6851 4.99342 20.3172 5.62556 20.3172 6.40521ZM24.3261 7.83806C24.2365 5.9469 23.8045 4.27172 22.4191 2.89154C21.0389 1.51137 19.3637 1.0794 17.4726 0.98458C15.5235 0.873955 9.68144 0.873955 7.73234 0.98458C5.84645 1.07413 4.17127 1.5061 2.78583 2.88628C1.40038 4.26646 0.973688 5.94163 0.878867 7.8328C0.768242 9.7819 0.768242 15.624 0.878867 17.5731C0.96842 19.4642 1.40038 21.1394 2.78583 22.5196C4.17127 23.8998 5.84118 24.3317 7.73234 24.4265C9.68144 24.5372 15.5235 24.5372 17.4726 24.4265C19.3637 24.337 21.0389 23.905 22.4191 22.5196C23.7993 21.1394 24.2312 19.4642 24.3261 17.5731C24.4367 15.624 24.4367 9.78717 24.3261 7.83806ZM21.808 19.6644C21.3971 20.6969 20.6017 21.4923 19.5639 21.9085C18.0099 22.5249 14.3224 22.3826 12.6051 22.3826C10.8878 22.3826 7.19501 22.5196 5.64627 21.9085C4.61377 21.4976 3.81833 20.7022 3.40217 19.6644C2.78583 18.1104 2.92806 14.4229 2.92806 12.7056C2.92806 10.9882 2.7911 7.29547 3.40217 5.74672C3.81306 4.71422 4.6085 3.91878 5.64627 3.50262C7.20028 2.88628 10.8878 3.02851 12.6051 3.02851C14.3224 3.02851 18.0152 2.89154 19.5639 3.50262C20.5964 3.91351 21.3919 4.70896 21.808 5.74672C22.4244 7.30074 22.2821 10.9882 22.2821 12.7056C22.2821 14.4229 22.4244 18.1157 21.808 19.6644Z"
            fill="white"/>
        </svg>
      </a>
      <!-- Twitter  -->
      <a v-if="twitterUrl"
         :href="twitterUrl"
         target="_blank"
         class="--small-size button --button-is-blue"
         aria-label="Twitter"
      >
        <svg width="15" height="18" viewBox="0 0 24 21"
             fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.5242 5.69314C21.5392 5.90277 21.5392 6.11245 21.5392 6.32209C21.5392 12.7162 16.6724 20.0837 7.7775 20.0837C5.03714 20.0837 2.49147 19.2901 0.350098 17.9125C0.739451 17.9573 1.11378 17.9723 1.51811 17.9723C3.77924 17.9723 5.86074 17.2086 7.52293 15.9059C5.39653 15.8609 3.61455 14.4683 3.00058 12.5515C3.3001 12.5964 3.59957 12.6264 3.91407 12.6264C4.34832 12.6264 4.78261 12.5665 5.1869 12.4617C2.97067 12.0124 1.30843 10.0657 1.30843 7.71472V7.65484C1.95232 8.01424 2.70111 8.23885 3.4947 8.26876C2.19191 7.40022 1.33839 5.91775 1.33839 4.24059C1.33839 3.34213 1.57794 2.51852 1.99726 1.79974C4.37823 4.73476 7.95718 6.65147 11.9703 6.86115C11.8955 6.50176 11.8505 6.12743 11.8505 5.75306C11.8505 3.08755 14.0069 0.91626 16.6873 0.91626C18.08 0.91626 19.3378 1.50027 20.2213 2.44367C21.3145 2.23403 22.3627 1.8297 23.2911 1.27565C22.9317 2.39877 22.168 3.34217 21.1647 3.94112C22.1381 3.83634 23.0815 3.56674 23.95 3.19241C23.2912 4.15075 22.4676 5.00427 21.5242 5.69314Z"
            fill="white"/>
        </svg>
      </a>
    </div>
    <p class="footer-copyright --text-is-gray"> 2020 © Pocket Cloud. All rights reserved</p>
  </footer>
</template>

<script>
import FeatureCard from '@/components/FeatureCard'
import ScalingoLink from '@/components/ScalingoLink'

export default {
  name: 'App',
  components: { ScalingoLink, FeatureCard },
  data () {
    return {
      twitterUrl: 'https://twitter.com/PocketCloudApp',
      facebookUrl: null,
      instagramUrl: null,
      pinterestUrl: null,
      googlePlayUrl: 'https://play.google.com/store/apps/details?id=fr.pocketcloud.pocket_cloud&hl=fr',
      appStoreUrl: null,
      features: [
        {
          title: 'Monitoring',
          icon: 'fas fa-chart-area',
          text: 'Keep an eye on what\'s happening on your application and how it perfoms.'
        },
        {
          title: 'Scaling',
          icon: 'fas fa-sliders-h',
          text: 'Increase or decrease the resources allowed to your app. Scale and re-scale as you want !'
        },
        {
          title: 'Sharing',
          icon: 'fas fa-handshake',
          text: 'Give access to your friends, collaborators and colleagues. And take it back if needed 😈'
        }
      ],
      email: null,
      contactEmail: 'hello@pocketcloud.fr',
      newsletterSuccess: false
    }
  },
  computed: {
    emailLink () {
      return `mailto${this.contactEmail}`
    }
  },
  methods: {
    async onSubmit () {
      try {
        const res = await fetch('https://blog-api.pocketcloud.fr/newsletter/new', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
          },
          body: JSON.stringify({ email: this.email })
        })
        if (res.ok) {
          this.newsletterSuccess = true
        }
      } catch (e) {
        console.log('error when making api call >', e)
      }
    }
  }
}
</script>

<style>
@import './css/reset.min.css';
@import './css/variables.css';
@import './css/styles.css';
@import './css/media-queries.css';

a.disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

a.discret {
  text-decoration: none;
}

.bigText {
  font-weight: 700;
  font-size: 19px;
}

.successMessage {
  font-size: 45px;
  font-weight: 700;
  height: 80px;
  text-align: center;
  color: #5BC1F2;
}
</style>
